// Menu items.
import IconBankBranches from '@/shared/assets/icons/icon-bank-branches.svg?react';
import IconApplicationCheck from '@/shared/assets/icons/icon-check-applications.svg?react';
import IconCreditApplications from '@/shared/assets/icons/icon-credit-applications.svg?react';
import IconCreditProduct from '@/shared/assets/icons/icon-credit-product.svg?react';
import IconDocuments from '@/shared/assets/icons/icon-documents.svg?react';
import IconEmployees from '@/shared/assets/icons/icon-employees.svg?react';
import IconCriteria from '@/shared/assets/icons/icon-farmer-criteria.svg?react';

import { PERMISSIONS } from '@/shared/const/permissions.const';
import {
  getRouteApplicationCheck,
  getRouteBankBranches,
  getRouteCreditApplications,
  getRouteCreditProducts,
  getRouteDocuments,
  getRouteEmployees,
  getRouteFarmerCriteria,
  getRouteMonitoringList,
} from '@/shared/const/router.const.ts';
import IconMonitoring from '@/shared/assets/icons/icon-monitoring.svg?react';

export const sidebarNavItems = [
  // {
  //   title: 'Страховые компании',
  //   url: getRouteICompanies(),
  //   icon: IconInsurance,
  // },
  {
    title: 'Филиалы банка',
    url: getRouteBankBranches(),
    icon: IconBankBranches,
    permission: PERMISSIONS.PARTNERS.INDEX,
    isReleased: true,
  },
  {
    title: 'Сотрудники',
    url: getRouteEmployees(),
    icon: IconEmployees,
    permission: PERMISSIONS.USERS.INDEX,
    isReleased: true,
  },
  {
    title: 'Кредитные анкеты',
    url: getRouteCreditApplications(),
    icon: IconCreditApplications,
    permission: PERMISSIONS.LOANS.INDEX,
    isReleased: true,
  },
  {
    title: 'Документы',
    url: getRouteDocuments(),
    icon: IconDocuments,
    permission: PERMISSIONS.DOCUMENTS.INDEX,
    isReleased: true,
  },
  {
    title: 'Проверка заявок',
    url: getRouteApplicationCheck(),
    icon: IconApplicationCheck,
    permission: PERMISSIONS.APPLICATIONS.INDEX,
    isReleased: true,
  },
  {
    title: 'Кредитный продукт',
    url: getRouteCreditProducts(),
    icon: IconCreditProduct,
    permission: PERMISSIONS.PRODUCTS.INDEX,
    isReleased: true,
  },
  {
    title: 'Мониторинг',
    url: getRouteMonitoringList(),
    icon: IconMonitoring,
    permission: PERMISSIONS.MONITORING.INDEX,
    isReleased: true,
  },
  {
    title: 'Оценка фермера',
    url: getRouteFarmerCriteria(),
    icon: IconCriteria,
    permission: PERMISSIONS.FARMER_CRITERIA.INDEX,
    isReleased: true,
  },
];
